const mutations = {
    identidyInfoMutation(state, value) {
        console.log('identidyInfoMutation',value)
        state.identidyInfo = { ...state.identidyInfo, ...value };
    },
};

export default mutations;